import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="flex justify-center items-center h-[50vh] md:h-[30vh]">
      <div
        className="ease-linear rounded-full border-8 border-t-8 border-gray-200 h-16 w-16"
        style={{
          borderTopColor: '#004225',
          animation: 'spinner 1.5s infinite linear',
        }}
      ></div>
      <style jsx="true">{`
        @keyframes spinner {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};

export default LoadingSpinner;